<template>
  <FormProvider :form="form">
    <FormLayout :labelCol="0" :wrapperCol="0" :labelWidth="120">
      <SchemaField :schema="operateFormSchema || {}" />
    </FormLayout>
  </FormProvider>
</template>
<script>
import Space from './Space';
import Input from './Input';
import Upload from './Upload';
import Picker from './Picker';
import TimePicker from './TimePicker';
import Quill from '@/components/Formily/quill';
import Text from './text';
import Link from './link';
import Images from './images.ts';
import Button from './button';
import FormTab from './formTab';
import Scanner from './scanner.js';
import MoveTabNavigation from './MoveTabNavigation.js';
import Export from './export.ts';
import Import from './import.ts';
import Location from './location.ts';
import Contact from './contact.ts';
import FormCollapse from './FormCollapse.js';
import Signature from './signature.ts';
import ArrayCards from './card.js';
import BackTop from './backTop.js';
import TimeButton from './timeButton.ts';
import ToStorageTable from '@/components/Formily/toStorageTable.ts';
import { searchTemplate } from '@/api/appDispose/pageTemplateApi';
import { postAny } from '@/api/baseApi';
import { createForm, onFormValuesChange } from '@formily/core';
import {
  formilyStepper,
  formilyCascader,
  formilyTimePicker,
  formilyFormItem,
  formilySwitch,
  formilyFormGrid,
} from './index.ts';
import CommonSelect from '@/components/Formily/CommonSelect';
import UserSelect from '@/components/Formily/userSelect';
import HotTable from '@/components/Formily/HotTable.ts';
import { FormProvider, createSchemaField } from '@formily/vue';
import {
  Form,
  Group,
  Submit,
  // ArrayTable,
  // Input,
  // Editable,
  PreviewText,
  Checkbox,
  // FormGrid,
  // Select,
  // Picker,
  // ArrayItems,
  // Space,
  FormLayout,
  // Reset,
  // Cascader,
  Radio,
  // Password,
  // TimePicker,
  // DatetimePicker,
} from '@formily/vant';
import { ArrayTable } from '@formily/element';
import NewArrayTable from './newArrayTable';

import NewArrayCards from './newcard';
import CountDownTimeButton from './CountDownTimeButton.ts';
// import Breadcrumb from '@/components/Breadcrumb';
import { Message, Dialog, MessageBox } from 'element-ui';

const fields = createSchemaField({
  components: {
    Form,
    Submit,
    FormItem: formilyFormItem,
    ArrayTable,
    ArrayCards,
    NewArrayTable,
    NewArrayCards,
    Input,
    // Editable,
    PreviewText,
    Checkbox,
    FormGrid: formilyFormGrid,
    Select: Picker,
    // ArrayItems,
    Space,
    FormLayout,
    // Reset,
    // Text,
    // Link,
    // Button,
    Radio,
    // Password,
    TimePicker,
    DatePicker: formilyTimePicker,
    TextArea: Input,
    Switch: formilySwitch,
    Password: Input,
    FormCollapse,
    Location,
    // FormTab,
    // ArrayCards,
    Upload,
    Cascader: formilyCascader,
    Quill,
    Text,
    Link,
    FormTab,
    Button,
    NumberPicker: formilyStepper,
    UserSelect,
    CommonSelect,
    Images,
    Scanner,
    MoveTabNavigation,
    Signature,
    Export,
    Import,
    Contact,
    BackTop,
    TimeButton,
    ToStorageTable,
    // ArrayCollapse,
    // Quill,
    // UserSelect,
    // CommonSelect,
    // HtmlText,
    CountDownTimeButton,
    HotTable,
  },
  scope: {
    ding: document.querySelector('#ding-mp3'),
    alarm: document.querySelector('#alarm-mp3'),
    finish: document.querySelector('#finish-mp3'),
    Message,
    Dialog,
    MessageBox,
  },
});

let vm;

export default {
  name: 'RenderPage',
  components: { FormProvider, FormLayout, ...fields },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: String,
      default: '',
    },
    tplKey: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: createForm({
        effects() {
          onFormValuesChange((form) => {
            vm && vm.$emit('change', form.values);
          });
        },
      }),
      pageId: '',
      operateFormSchema: {},
      values: {},
    };
  },
  async created() {
    vm = this;
    await this.getTemplate();
    if (this.value && Object.keys(this.value).length) {
      this.form.setValues({ ...this.value });
    } else this.getParams();
  },
  methods: {
    async getTemplate() {
      try {
        const { data } = await searchTemplate({
          SearchCondition: { Id: this.tplKey ? '' : this.id, TemplateKey: this.tplKey },
        });
        const [{ TemplateStyle, TemplateParams }] = data.List;
        const res = this.getOperateFormSchema(TemplateStyle);
        this.operateFormSchema = res;
        console.log(res, 55);
        if (!this.value || !Object.keys(this.value).length)
          this.form.setValues({ ...JSON.parse(TemplateParams || '{}') });
        this.$emit('ready', this.form);
      } catch (e) {
        this.$message.error(e);
      }
    },
    formatSchema(val) {
      try {
        this.recursiveDelete(val.schema ? val.schema : val);
        this.disabled && this.recursiveDisable(val.schema ? val.schema : val);
        const str = JSON.stringify(val, this.formatJson).replace(
          /\/relay\/api/g,
          '/relay/ifob/api'
        );

        const res = JSON.parse(str);
        if (res && res.schema) {
          return res.schema;
        }
        return res || {};
      } catch (e) {
        console.log(e);
        return {};
      }
    },
    formatJson(key, value) {
      if (key === 'labelWidth') return undefined;
      if (key === 'x-component' && value === 'Input.TextArea') return 'TextArea';
      if (key === 'enum' && Array.isArray(value))
        return value.map((item) =>
          typeof item === 'object' ? { ...item, name: item.name || item.value } : item
        );

      return value;
    },
    recursiveDelete(obj) {
      if (!obj) return;
      if (obj.properties) {
        this.recursiveDelete(obj.properties);
      }
      Object.values(obj).map((property) => {
        if (property.properties) {
          this.recursiveDelete(property.properties);
        }
        if (property.items) {
          this.recursiveDelete(property.items);
        }
        if (
          [
            'DatePicker',
            'Select',
            'TimePicker',
            'Input',
            'Input.TextArea',
            'Cascader',
            'Space',
            'FormGrid',
          ].includes(property['x-component'])
        ) {
          this.removeDecorator(property);
        }
        if (
          !property.title &&
          ['ArrayTable', 'ArrayCard','NewArrayTable', 'NewArrayCard', 'ToStorageTable'].includes(property['x-component'])
        ) {
          this.removeDecorator(property);
        }
        if (property['x-component'] === 'ArrayTable.Column' && Object.values(obj).length > 2) {
          const decorator = property;
          decorator['x-component-props'] = {
            ...decorator['x-component-props'],
            width: decorator['x-component-props'].width || 150,
          };
        }
        if (property['x-component'] === 'NewArrayTable.Column' && Object.values(obj).length > 2) {
          const decorator = property;
          decorator['x-component-props'] = {
            ...decorator['x-component-props'],
            width: decorator['x-component-props'].width || 150,
          };
        }
      });
    },
    // 移动端会把字段的 FormItem 装饰器移除（见 recursiveDelete）。
    // 被移除装饰器的字段，其“表单项容器样式”（x-decorator-props.style）会随之失效，
    // 这里在移除装饰器的同时把容器样式合并到组件样式（x-component-props.style），
    // 使 ReactiveField 将其作为组件 style 应用到输入控件根节点（如文字颜色）。
    // 注意：只处理“本会被移除装饰器”的字段，不改变其它字段的 x-decorator-props 语义。
    removeDecorator(property) {
      property['x-decorator'] = null;
      const decoratorProps = property['x-decorator-props'];
      if (decoratorProps && decoratorProps.style) {
        property['x-component-props'] = {
          ...(property['x-component-props'] || {}),
          style: {
            ...((property['x-component-props'] && property['x-component-props'].style) || {}),
            ...decoratorProps.style,
          },
        };
      }
    },
    recursiveDisable(obj) {
      if (!obj) return;
      if (obj.properties) {
        this.recursiveDisable(obj.properties);
      }
      Object.values(obj).map((property) => {
        if (property.properties) {
          this.recursiveDisable(property.properties);
        }
        if (property.items) {
          this.recursiveDisable(property.items);
        }
        if (property['x-component']) {
          const item = property;
          item['x-pattern'] = 'readonly';
        }
      });
    },
    async getParams() {
      if (!this.url) return;
      try {
        const { data } = await postAny(this.url, this.params);
        if (!!data && !!Object.keys(data).length) this.form.setValues({ ...data.data });
      } catch (e) {
        this.$message.error(e);
      }
    },
    getOperateFormSchema(data) {
      try {
        const formSchema = this.formatSchema(JSON.parse(data || '{}'));
        console.log(formSchema, 66);
        return formSchema || {};
      } catch (e) {
        console.log(e);
        return {};
      }
    },
  },
};
</script>
<style lang="less" scoped>
.formily-todo {
  /deep/ .ql-picker-label {
    display: inline-flex;
    align-items: center;
  }
  /deep/ .ql-picker-options {
    z-index: 999;
  }
  /deep/ .ql-picker {
    display: inline-flex;
    align-items: center;
  }
  /deep/ .formily-vant-preview-text::after,
  /deep/ .van-cell::after {
    display: block;
  }
  /deep/ .van-cell__value .van-radio-group,
  /deep/ .van-cell__value .van-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }
  /deep/ .van-field__label .van-cell {
    padding: 0;
    overflow: inherit;
    white-space: pre-line;
  }
  /deep/ .van-stepper__input {
    width: auto;
  }
  /deep/ .formily-element-array-table,
  /deep/ .formily-element-array-cards {
    width: 100%;
  }
  /deep/ .formily-vant-preview-input-title {
    width: auto;
  }
  /deep/ .van-field__label .van-cell::after {
    border: none;
  }
  /deep/ .van-field--disabled {
    background: #f7f8fa;
    transition: background 0.2s ease-out;
  }
  // 设计器“容器样式”字体颜色：vant 输入元素自身有显式 color，
  // 在容器设置了颜色（style 含 color）时让输入内容继承外层颜色
  /deep/ .van-field[style*="color:"] .van-field__control:not(:disabled) {
    color: inherit;
  }
  /deep/ .van-field {
    transition: background 0.2s ease-out;
  }

  // ===== FormTab 同步 PC 端默认形式，并按 type 区分 line/card =====
  /deep/ .formily-element-form-tab {
    background: #ffffff;

    .van-tabs__nav {
      background: #ffffff;
    }

    .van-tab {
      color: var(--form-tab-title-font-color, #64748b) !important;
      font-size: 14px;
      font-weight: 500;
      background: #ffffff !important;
      transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);

      .van-tab__text > div {
        color: var(--form-tab-title-font-color, #64748b) !important;
        font-weight: 500;
      }

      &:hover {
        color: #4096ff !important;
      }

      &:hover .van-tab__text > div {
        color: #4096ff !important;
      }

      &.van-tab--active,
      &.van-tab--active .van-tab__text {
        color: #1677ff !important;
        font-weight: 600 !important;
      }

      &.van-tab--active .van-tab__text > div {
        color: #1677ff !important;
        font-weight: 600;
      }

      &.van-tab--disabled {
        color: #c0c4cc !important;
      }

      &.van-tab--disabled .van-tab__text > div {
        color: #c0c4cc;
      }
    }
  }

  /deep/ .formily-element-form-tab--line {
    .van-tabs__wrap {
      height: 44px;
      border-bottom: 1px solid #e4e7ed;
    }

    .van-tabs__line {
      display: block;
      height: 3px;
      background-color: #1677ff;
      border-radius: 2px;
    }
  }

  /deep/ .formily-element-form-tab--card {
    .van-tabs__wrap {
      height: 44px;
      border-bottom: var(--form-tab-card-border-width, 1px) solid var(--form-tab-card-border-color, #e4e7ed);
    }

    .van-tabs__line {
      display: none;
    }

    .van-tabs__nav--card {
      height: 44px;
      margin: 0;
      overflow: hidden;
      background: #ffffff;
      border: var(--form-tab-card-border-width, 1px) solid var(--form-tab-card-border-color, #e4e7ed);
      border-bottom: none;
      border-radius: 4px 4px 0 0;

      .van-tab {
        color: var(--form-tab-title-font-color, #1e293b) !important;
        line-height: 42px;
        background: #ffffff !important;
        border-right: var(--form-tab-card-border-width, 1px) solid var(--form-tab-card-border-color, #e4e7ed);

        .van-tab__text > div {
          color: var(--form-tab-title-font-color, #1e293b) !important;
        }

        &:last-child {
          border-right: none;
        }

        &:hover {
          color: #4096ff !important;
        }

        &:hover .van-tab__text > div {
          color: #4096ff !important;
        }

&.van-tab--active {
          color: #1677ff !important;
          background: var(--form-tab-card-active-background, #ffffff) !important;
        }

        &.van-tab--active .van-tab__text > div {
          color: #1677ff !important;
        }
      }
    }
  }
}
</style>
